<template>
  <upload-list-item-field label="Pre-screened Outcome">
    <v-icon size="small" :color="color">{{ icon }}</v-icon>
    {{ label }}
  </upload-list-item-field>
</template>

<script>
import UploadListItemField from '@/components/UploadsPage/UploadListItemField';
import { RelevanceAssessment } from '@/enums';

const ASSESSMENT_TO_PROPS = {
  [RelevanceAssessment.RELEVANT]: {
    icon: 'thumb_up_alt',
    label: 'Relevant',
    color: 'success',
  },
  [RelevanceAssessment.NOT_RELEVANT]: {
    icon: 'thumb_down_alt',
    label: 'Not Relevant',
    color: 'error',
  },
};

export default {
  name: 'UploadListItemFieldSource',
  components: { UploadListItemField },
  props: {
    outcome: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(RelevanceAssessment).includes(value),
    },
  },
  computed: {
    label() {
      return ASSESSMENT_TO_PROPS[this.outcome].label;
    },
    icon() {
      return ASSESSMENT_TO_PROPS[this.outcome].icon;
    },
    color() {
      return ASSESSMENT_TO_PROPS[this.outcome].color;
    },
  },
};
</script>
